import { useEffect } from 'react';
import { business } from '../data/content';
const TITLE = 'Utility & Commercial Fence Contractor | South Lyon Fence';
const DESCRIPTION = 'South Lyon Fence installs utility and commercial fencing, gates, and specialty perimeter systems across Michigan, Indiana, and Ohio. Serving since 1983.';

// NOTE: production measurement (analytics / tag manager) is intentionally NOT installed here.
// It must be configured on the live domain with the client's own account IDs.
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function setLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}
export function HeadMeta() {
  useEffect(() => {
    document.title = TITLE;
    document.documentElement.lang = 'en';
    setMeta('name', 'description', DESCRIPTION);
    // Redesign preview must not compete with the live production site in search results.
    setMeta('name', 'robots', 'noindex,follow');
    setMeta('name', 'viewport', 'width=device-width, initial-scale=1');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', business.name);
    setMeta('property', 'og:title', TITLE);
    setMeta('property', 'og:description', DESCRIPTION);
    setMeta('property', 'og:url', business.productionUrl);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', TITLE);
    setMeta('name', 'twitter:description', DESCRIPTION);
    setLink('canonical', business.productionUrl);
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: business.name,
      url: business.productionUrl,
      telephone: '+1-248-437-4445',
      email: business.email,
      foundingDate: business.since,
      address: {
        '@type': 'PostalAddress',
        streetAddress: business.address.street,
        addressLocality: business.address.city,
        addressRegion: business.address.state,
        postalCode: business.address.zip,
        addressCountry: 'US'
      },
      areaServed: business.states.map(state => ({
        '@type': 'State',
        name: state
      }))
    };
    const scriptId = 'slf-localbusiness-jsonld';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(jsonLd);
  }, []);
  return null;
}